import React from 'react';
import Heading from '../../../components/controls/Typography/Heading';
import { TextReset } from '../../../components/controls/Typography/TextBody';
import { useQuestionBlock } from '../../../utils/useRecommendation';
import { createMarkup } from '../../../utils/validateForm';
import Question from './components/Question';
import Rubrics from './components/Rubrics';

import './QuestionBlock.less';

/**
 *
 * @param {{
 *  blockId:number;
 * }} props
 * @returns
 */
const QuestionBlock = (props) => {
  const { item: block, isRatings } = useQuestionBlock(props.blockId);

  // All the questions are called interated in Question component and rubrics are loaded seperately in Rubrics component
  return block ? (
    <div className="container lsn-question-group lsn-question-group-dynamic" data-block-name={block.blockName}>
      <div className="lsn-question-group-header">
        <Heading bold level={3} tabIndex={0} asSpan aria-describedby={`${block.id}-instructions`} aria-label={`Question block ${block.blockName}`}>{block.blockName}</Heading>
        <TextReset id={`${block.id}-instructions`} hidden={!block.instructions}>
          <span dangerouslySetInnerHTML={createMarkup(block.instructions)}></span>
        </TextReset>
      </div>
      {
        isRatings
          ? <Rubrics questionBlockId={props.blockId} />
          : block.evaluationQuestions.map((blockEvalQuest, key) => (
            <Question questionId={blockEvalQuest.id} key={key} />
          ))
      }
      <div className='divider'></div>
    </div>
  ) : null;
}

export default QuestionBlock;
